import * as Sentry from '@sentry/nuxt'

export default function useSentry() {
  const { user } = useAuth()
  /**
   * Log an error to Sentry.
   * @param errorMessage the message to log.
   * @param contextVariables Includes variables that provide context
   */
  function reportError(
    errorMessage: string,
    contextVariables: Record<string, unknown>,
  ) {
    Sentry.captureException(new Error(errorMessage), {
      extra: contextVariables,
    })
  }

  watch(user, () => {
    if (user.value) {
      Sentry.setUser({
        username: user.value.displayName!,
        email: user.value.email!,
        id: user.value.uid,
      })
    }
    else {
      Sentry.setUser(null)
    }
  })

  return { reportError }
}
